import * as React from 'react';
export const digitaloceanSvg = React.forwardRef(function digitaloceanSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0080FF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.96 27.96v-4.638c4.908 0 8.718-4.868 6.833-10.034a6.93 6.93 0 0 0-4.135-4.135C13.49 7.28 8.624 11.078 8.624 15.986H4C4 8.163 11.566 2.061 19.77 4.624c3.58 1.125 6.44 3.973 7.552 7.552 2.563 8.217-3.525 15.783-11.363 15.783Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.973 23.336h-4.61v-4.611h4.61v4.611Zm-4.61 3.552H7.81v-3.552h3.553v3.552ZM7.81 23.336H4.84v-2.97h2.97v2.97Z',
      fill: '#fff',
    }),
  );
});
digitaloceanSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var digitalocean = {
  category: 'brand',
  colorable: false,
  name: 'digitalocean',
  svg: digitaloceanSvg,
};
